import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { favoriteItem /* , removeFavoriteItem */ } from '@bd/bdcore-data/build/Favorites/actions';
import withData from '@bd/bdcore-data';


class FavoriteEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      favoriteNotes: get(props, 'favorite.notes', ''),
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  handleInput = event => {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      [key]: value,
    });
  }

  save = e => {
    const { favorite, dispatch } = this.props;
    const { favoriteNotes: notes } = this.state;

    dispatch(favoriteItem({
      ...favorite,
      notes,
    }));
    this.closeModal(e);
  }

  render() {
    const { className } = this.props;
    const { favoriteNotes } = this.state;

    return (
      <form className={className}>
        <div className="FavoriteEdit_Body p-3">
          <label htmlFor="favoriteNotes">Notes</label>
          <textarea
            name="favoriteNotes"
            id="favoriteNotes"
            className="form-control FavoriteEdit_notes"
            defaultValue={favoriteNotes}
            onChange={this.handleInput}
          />
          <button type="button" className="btn" onClick={this.save}>Save</button>
        </div>
      </form>
    );
  }
}

FavoriteEdit.propTypes = {
  className: PropTypes.string,
  favorite: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

FavoriteEdit.defaultProps = {
  className: undefined,
  children: undefined,
};

export default withData({ favorites: true })(FavoriteEdit);



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/Favorites/FavoriteEdit.js